import React from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionWrapper } from '../../components/Section'
import SuccessMessage from '../../components/SuccessMessage'
import messages from './messages'

export const renderSuccess = __html => (
  <SuccessMessage dangerouslySetInnerHTML={{ __html }} />
)

function RegisterSuccess() {
  return (
    <SectionWrapper>
      <FormattedMessage {...messages.successMessageHTML}>
        {renderSuccess}
      </FormattedMessage>
    </SectionWrapper>
  )
}

export default RegisterSuccess
